export let OrdenesComponent = {
    selector: 'ordenesList',
    template: require('./ordenes.html'),
    bindings: {
        ordenes: '<'
    },
    controller: class {

        /*@ngInject*/
        constructor(OrdenesService) {
            Object.assign(this, {OrdenesService});
            this.estado = 'pendiente';
        }

        limit = 20;
        loadMoreVisible = true;

        setEstado(tipo) {
            if (this.estado !== tipo) {
                this.estado = tipo;

                // Restart values
                this.limit = 20;
                this.loadMoreVisible = true;

                switch (tipo) {
                    case 'pendiente':
                        this.OrdenesService.getOrdenesPendientes(this.limit)
                            .then(ordenes => {
                                this.ordenes = ordenes.data;
                                if (ordenes.data.length < this.limit)
                                    this.loadMoreVisible = false;
                            });
                        break;
                    case 'enProceso':
                        this.OrdenesService.getOrdenesEnProceso(this.limit)
                            .then(ordenes => {
                                this.ordenes = ordenes.data;
                                if (ordenes.data.length < this.limit)
                                    this.loadMoreVisible = false;
                            });
                        break;
                    case 'finalizada':
                        this.OrdenesService.getOrdenesFinalizadas(this.limit)
                            .then(ordenes => {
                                this.ordenes = ordenes.data;
                                if (ordenes.data.length < this.limit)
                                    this.loadMoreVisible = false;
                            });
                        break;
                }
            }
        }

        cargarMas() {
            this.limit += 20;
            switch (this.estado) {
                case 'pendiente':
                    this.OrdenesService.getOrdenesPendientes(this.limit)
                        .then(ordenes => {
                            this.ordenes = ordenes.data;
                            if (ordenes.data.length < this.limit)
                                this.loadMoreVisible = false;
                        });
                    break;
                case 'enProceso':
                    this.OrdenesService.getOrdenesEnProceso(this.limit)
                        .then(ordenes => {
                            this.ordenes = ordenes.data;
                            if (ordenes.data.length < this.limit)
                                this.loadMoreVisible = false;
                        });
                    break;
                case 'finalizada':
                    this.OrdenesService.getOrdenesFinalizadas(this.limit)
                        .then(ordenes => {
                            this.ordenes = ordenes.data;
                            if (ordenes.data.length < this.limit)
                                this.loadMoreVisible = false;
                        });
                    break;
            }
        }

    }
};



// WEBPACK FOOTER //
// ./client/app/ordenes-route/ordenes.component.js